// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CharacterAuthorizeSvg from '@rsuite/icon-font/lib/people/CharacterAuthorize';
var CharacterAuthorize = createSvgIcon({
  as: CharacterAuthorizeSvg,
  ariaLabel: 'character authorize',
  category: 'people',
  displayName: 'CharacterAuthorize'
});
export default CharacterAuthorize;